// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { CampaignAction } from './campaign-action';
import { CampaignOptOut } from './campaign-opt-out';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class Campaign extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  created!: Date;
  createdBy?: string;
  deleted?: Date;
  deletedBy?: string;
  endDate?: Date;
  name?: string;
  startDate!: Date;
  actions!: CampaignAction[];
  optOuts!: CampaignOptOut[];
}

